import HttpService from "./HttpService";

let atividadeComplementar = {

    enviar: (atividade, nomeAtividade, anos, escolas) => {
        return HttpService.backApi.post(`atividadecomplementar/enviar?nome=${nomeAtividade}&anos=${anos}&escolas=${escolas}`, atividade)
    },

    getAllByAno: (ano) => {
        return HttpService.backApi.get(`atividadecomplementar/all/${ano}`)
    },

    delete: (ano, atividades) => {
        return HttpService.backApi.delete(`atividadecomplementar/deletar/${ano}/${atividades}`)
    },

    getAtividade(atividade) {
        return HttpService.backApi.get(`atividadecomplementar/get-pdf/${atividade}`)
    },

    getListaAtividades(ids) {
        return HttpService.backApi.get(`atividadecomplementar/get-list-pdf/${ids}`)
    },

    getEscolasParaSelecao() {
        return HttpService.backApi.get(`atividadecomplementar/escolas-para-selecao`)
    },

    atualizarEscolasDaAtv(body) {
        return HttpService.backApi.post(`atividadecomplementar/atualizar-escola-atividade`, body)
    },

    getEscolasDaAtividade(idAtividadeComplementar) {
        return HttpService.backApi.get(`atividadecomplementar/escolas-da-atividade?idAtividadeComplementar=${idAtividadeComplementar}`)
    }

}

export default atividadeComplementar;